/* SilkPearl hero slider.
 *
 * Deliberately small: cross-fade between slides, dots to jump, auto-advance
 * that pauses on hover and on focus.
 *
 * Two things learned the hard way in this theme and applied here:
 *   - requestAnimationFrame is paused in a background tab, so the timer is a
 *     plain setInterval and the class flip forces no layout read.
 *   - Do not cache DOM nodes across a Section Rendering API re-render. This
 *     re-queries on init and re-inits when Shopify replaces the section.
 */
(function () {
  var TICK = 6000;

  function init(root) {
    var slides = root.querySelectorAll('[data-sp-hero-slide]');
    if (slides.length < 2) return;
    var dots = root.querySelectorAll('[data-sp-hero-dot]');
    var i = 0;
    var timer = null;
    var still = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function show(n) {
      i = (n + slides.length) % slides.length;
      for (var k = 0; k < slides.length; k++) {
        slides[k].classList.toggle('is-active', k === i);
        if (dots[k]) {
          dots[k].classList.toggle('is-active', k === i);
          dots[k].setAttribute('aria-selected', k === i ? 'true' : 'false');
        }
      }
    }
    function start() { if (!still && !timer) timer = setInterval(function () { show(i + 1); }, TICK); }
    function stop() { if (timer) { clearInterval(timer); timer = null; } }

    for (var k = 0; k < dots.length; k++) {
      (function (n) {
        dots[n].addEventListener('click', function () { stop(); show(n); start(); });
      })(k);
    }
    root.addEventListener('mouseenter', stop);
    root.addEventListener('mouseleave', start);
    root.addEventListener('focusin', stop);
    root.addEventListener('focusout', start);
    /* A tab that is not visible should not burn through slides unseen. */
    document.addEventListener('visibilitychange', function () {
      if (document.hidden) stop(); else start();
    });

    show(0);
    start();
  }

  function boot(scope) {
    var roots = (scope || document).querySelectorAll('.sp-hero');
    for (var n = 0; n < roots.length; n++) init(roots[n]);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); });
  else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
